import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash.debounce'

import { NewsFilter } from './newsFilter'
import TextInput from '../../../midasComponents/components/TextInput'
import { getText } from '../../../internal/TextLabels'
import FilterModule from '../../../components/common/FilterModule/FilterModule'
import DateRangePicker from '../../../components/common/DateRangePicker/DateRangePicker'

import styles from './AdminNewsFilter.module.scss'

const AdminNewsFilter = ({ filter, onChange }) => {
  const [searchFilter, setSearchFilter] = useState(filter)
  const [filters, setFilters] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  const debouncedSearch = useCallback(
    debounce(
      value => setSearchFilter({ ...searchFilter, searchTerm: value }),
      300,
    ),
    [],
  )

  const onSetFilters = incomingFilters => {
    const existingFilters = [...filters]

    const newFilters = incomingFilters.filter(
      incomingFilter =>
        !existingFilters.some(
          existingFilter => existingFilter.value === incomingFilter.value,
        ),
    )

    setFilters([...existingFilters, ...newFilters])
    setSearchFilter(filter)
  }

  const handleSearch = search => {
    setSearchTerm(search)
    debouncedSearch(search)
  }

  useEffect(() => {
    onChange(searchFilter)
  }, [searchFilter])

  useEffect(() => {
    const sortedFilters = {
      audiences: [],
      tags: [],
    }
    if (filters.length !== 0) {
      filters.forEach(f => {
        switch (f.field) {
          case 'COUNTRY':
            sortedFilters.audiences.push({ country: f.value })
            sortedFilters.audiences.push({ everyone: 'everyone' })
            break
          case 'TAG':
            sortedFilters.tags.push(f.value)
            break
          case 'PUBLISHED':
            sortedFilters.visible = f.value === 'true'
            break
          default:
            break
        }
      })
    }
    setSearchFilter({ ...searchFilter, ...sortedFilters })
  }, [filters])

  const onRemoveFilter = f => {
    setFilters(f)
    setSearchFilter(filter)
  }

  return (
    <div className={styles.page}>
      <TextInput
        id="filter-value-input"
        type="text"
        skipValidation
        value={searchTerm}
        onChange={e => handleSearch(e.target.value)}
        placeholder={getText('default.search')}
      />
      <DateRangePicker
        startDate={searchFilter.publicationDate}
        endDate={searchFilter.endDate}
        customDate
        selectDate={(end, start) =>
          setSearchFilter({
            ...searchFilter,
            publicationDate: new Date(start).toISOString(),
            endDate: new Date(end).toISOString(),
          })
        }
        optionalMaxDate
      />
      <FilterModule
        filters={filters}
        values={NewsFilter}
        setFilters={onSetFilters}
        onRemoveFilter={onRemoveFilter}
      />
    </div>
  )
}

AdminNewsFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default AdminNewsFilter
